import axios from 'axios'
import store from '../store'
import qs from 'qs'
import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/auth'

export default ({ router, Vue }) => {
	Vue.prototype.$axios = axios

	axios.defaults.baseURL = process.env.API_URL
	axios.defaults.timeout = 0

	refreshToken(axios, router)
}

function refreshToken(instance, router) {
	var isRefreshing = false
	var subscribers = []

	function subscribeTokenRefresh(cb) {
		subscribers.push(cb)
	}

	function onRrefreshed(token) {
		subscribers.map(cb => cb(token))
	}

	instance.interceptors.response.use(undefined, err => {
		const { config, response: { status } } = err
		const originalRequest = config

		if (status === 401 && store.getters['common/refresh_token'] && !store.getters['common/webservice_token']) {
			if (!isRefreshing) {
				isRefreshing = true

				let data = {
					grant_type: 'refresh_token',
					refresh_token: store.getters['common/refresh_token']
				}

				let headers = {
					headers: {
						'content-type': 'application/x-www-form-urlencoded',
						'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET)
					}
				}

				instance.post('/o/token/', qs.stringify(data), headers)
				.then(response => {
					store.dispatch('common/SET_ACCESS_TOKEN', [response.data.access_token, response.data.refresh_token, response.data.user_firebase_token])

					if (response.data.user_firebase_token) {
						firebase.auth().signInWithCustomToken(response.data.user_firebase_token)
						.then(() => {
							isRefreshing = false
							onRrefreshed(response.data.access_token)
							subscribers = []
						})
						.catch(function(error) {
                            var errorCode = error.code
                            var errorMessage = error.message
                        })
					}
					else {
						isRefreshing = false
						onRrefreshed(response.data.access_token)
						subscribers = []
					}
				})
				.catch(e => {
					store.dispatch('common/SET_ACCESS_TOKEN', ['', '', ''])
					router.replace({ name: 'login' })
					console.log(e)
				})
			}
			const requestSubscribers = new Promise(resolve => {
				subscribeTokenRefresh(token => {
					originalRequest.headers = {}
					originalRequest.headers.Authorization = `Bearer ${token}`
					resolve(axios(originalRequest))
				})
			})
			return requestSubscribers
		}
		else if (status === 401 && !store.getters['common/refresh_token'] && !store.getters['common/webservice_token']) {
			router.replace({ name: 'login' })
		}
		else if (status === 401 && store.getters['common/webservice_token']) {
			store.dispatch('common/SET_ACCESS_TOKEN', ['', '', ''])
			store.dispatch('common/SET_WEBSERVICE_TOKEN', [''])
			router.replace({ name: 'login' })
		}
		return Promise.reject(err)
	})
}
